import { UserOutlined } from '@ant-design/icons';
import { Avatar, Button, Card, Space } from 'antd';
import React, { useCallback } from 'react';
import styled from 'styled-components';
import { Title } from '../layouts/BasicProLayout/UserSelfDrawer/styled';
import { useAccount } from './contexts/AccountContextManager';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: -50px;

    .ant-card-body {
        background-color: transparent;
        padding: 16px;
    }

    .ant-card {
        width: calc(100% - 48px);
        background-color: #eff0f1;
        border-radius: 10px;
    }

    .ant-card-actions {
        background-color: transparent;
        border-radius: 0 0 10px 10px;
    }
`;

const CircleButton = styled(Button).attrs(() => ({
    shape: 'circle',
    type: 'link',
}))`
    && {
        background: white;
        height: 100%;
        padding: 5px;
        position: relative;
        top: 50px;
        left: 0px;
        margin: auto;
        z-index: 100;
    }
`;

const StyledSpace = styled(Space).attrs(() => ({
    direction: 'vertical',
    size: 0,
}))`
    width: 100%;
    text-align: center;
    margin-top: 48px;
`;

type ProfileCardProps = {
    actions?: React.ReactNode[];
    extra?: React.ReactNode;
    onAvatarClicked?: () => void;
};

const ProfileCard = ({ actions, extra, onAvatarClicked }: ProfileCardProps) => {
    const user = useAccount(true);

    if (!user) {
        return null;
    }

    const handleAvatarClicked = useCallback(() => {
        if (onAvatarClicked) {
            onAvatarClicked();
        }
    }, [onAvatarClicked]);

    return (
        <Container>
            <CircleButton onClick={handleAvatarClicked}>
                <Avatar icon={<UserOutlined />} size={80} src={user.profileImage?.url} />
            </CircleButton>
            <Card actions={actions}>
                <StyledSpace>
                    <Title>{user.displayName}</Title>
                </StyledSpace>
                {extra}
            </Card>
        </Container>
    );
};

export default ProfileCard;
